import MicrosoftLogo from "./Img/MicrosoftLogo.svg";
import "./AuthMicrosoftButton.scss";

export const AuthMicrosoftButton = () => {
    const url = `https://${
        process.env.REACT_APP_DEPLOY_PLATFORM === "stage" ? "stage-" : ""
    }license.adaware.com`;

    // Send only the SPA origin (not the API host). The backend appends the
    // callback path itself and 302s with the JWT in the URL fragment:
    // <origin>/auth/callback#token=<jwt>
    const returnUrl = encodeURIComponent(window.location.origin);
    const redirectUrl = `${url}/api/User/login-microsoft?returnUrl=${returnUrl}`;

    return (
        <a className="auth_microsoft_button" href={redirectUrl}>
            <img
                src={MicrosoftLogo}
                alt="Microsoft Logo"
                className="auth_microsoft_button__logo"
            />
            <span className="auth_microsoft_button__text">Microsoft</span>
        </a>
    );
};
